export const AppConstants = {
  TokenId: "X-ACPBUS-Token",
  ProfileStorageId: "user-profile",
  TimeZone: "X-Timezone",
  NoImageDefault: "assets/img/no-image.png",
  ProductImageDefault: "assets/img/no-image-produk.png",
  AccountStatusId: "account-status",
  SessionExpired: "expired",
  B2BStatus: "b2bStatus",
  GTStatus: 'gtStatus',
  TOPStatus: 'topStatus',
  IsLogin: 'isLogin',
  RegisterTokenId: "X-ACPBUS-Register-Token",
  PopupMessagePaymentCode: "PYGT",
  PopupMessageCancelTransactionCode: "CTBUGT",
  PopupMessageReminderTransactionCode: "RPYGT",
  PopupMessagePaymentProofCode: "RPTPGT",
  PopupMessageRegistrationCode: "ALRTREGGT",
  PopupMessageRegistrationNPWPCode: "ALRTREGNPWPGT",
  PopupMessageRegistrationSuccessCode: "ALRTREGSUCGT"
};
